import { createSlice } from "@reduxjs/toolkit";

const initialImportRequest = {
    bmfExchangeRateFileLink: null,
    targetCurrencyCode: "USD",
    exchangeRate: null,
    month: null,
    year: null,
};

const initialGetRequest = {
    year: new Date().getFullYear(),
    targetCurrencyCode: "USD",
};

const initialState = {
    isLoading: false,
    isUpdateLoading: false,
    exchangeRates: [],
    importRequest: initialImportRequest,
    getRequest: initialGetRequest,
    errorMessage: null,
    importErrorMessage: null,
};

const exchangeRateSlice = createSlice({
    name: "SearchTool",
    initialState,
    reducers: {
        setImportRequest(state, action) {
            state.importRequest = action.payload;
        },
        setGetRequest(state, action) {
            state.getRequest = action.payload;
        },

        getExchangeRatesRequest(state) {
            state.errorMessage = null;
            state.isLoading = true;
        },
        getExchangeRatesSuccess(state, action) {
            state.exchangeRates = action.payload;
            state.isLoading = false;
        },
        getExchangeRatesFailure(state, action) {
            state.errorMessage = action.payload;
            state.isLoading = false;
        },

        importExchangeRatesRequest(state) {
            state.importErrorMessage = null;
            state.isUpdateLoading = true;
        },
        importExchangeRatesSuccess(state, action) {
            state.exchangeRates = action.payload;
            state.isUpdateLoading = false;
            state.importRequest = initialImportRequest;
        },
        importExchangeRatesFailure(state, action) {
            state.importErrorMessage = action.payload;
            state.isUpdateLoading = false;
        },
    },
});

export default exchangeRateSlice;
